import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListSeasons from '../../components/seasons/list-seasons.component';

const ContentSeriesSeasons = () => {
  const { id } = useParams();
  const pageTitle = PAGE_TITLE_LIST.CONTENT_SERIES_SEASONS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSeasons dataId={id || 0} />
    </AppLayout>
  );
};

export default ContentSeriesSeasons;
